import Amplify, { Hub, Logger } from 'aws-amplify';
import CookieStorage from './cookieStorage'; // Amplify.Logger.LOG_LEVEL = 'VERBOSE';

var alex = new Logger('Alexander_the_auth_watcher');

alex.onHubCapsule = function (capsule) {
  switch (capsule.payload.event) {
    case 'signIn':
      alex.error('user signed in'); // [ERROR] Alexander_the_auth_watcher - user signed in

      break;

    case 'signUp':
      alex.error('user signed up');
      break;

    case 'signOut':
      alex.error('user signed out');
      break;

    case 'signIn_failure':
      alex.error('user sign in failed');
      break;

    case 'configured':
      alex.error('the Auth module is configured');
      break;

    default:
  }
};

Hub.listen('auth', alex);
export var awsConfig = {
  Analytics: {
    disabled: true
  },
  Auth: {
    region: process.env.USER_POOL_REGION,
    userPoolId: process.env.USER_POOL_ID,
    userPoolWebClientId: process.env.USER_POOL_WEB_CLIENT_ID,
    storage: new CookieStorage(),
    identityPoolId: process.env.IDENTITY_POOL_ID
  }
};

function configureAmplify() {
  Amplify.configure(awsConfig);
}

export default configureAmplify;